import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MapElement } from '../../shared/map/map-element.model';
import { GeometryObject } from 'geojson';
import { ElementTextService } from '../../shared/element-text.service';
import { ElementTextModel } from '../../shared/element-text.model';
import 'linkifyjs';
import linkifyHtml from 'linkifyjs/html';

/*
 * TODO: Check if there exists any concrete use case, concerning the usage of 'linkify'.
 */
@Component({
  selector: 'qm-element-text',
  templateUrl: './element-text.component.html',
  styleUrls: ['./element-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ElementTextComponent implements OnInit, OnChanges {

  @Input()
  public selectedFeature: MapElement<GeometryObject>;
  @Output()
  testi: boolean = false;
  public newDescription: ElementTextModel = new ElementTextModel();
  public objectDescriptions: ElementTextModel[] = [];
  public text: string = null;
  public show: boolean = false;

  constructor(private elementTextService: ElementTextService,
              private changeDetector: ChangeDetectorRef) {}

  ngOnInit() {
    this.getLinks();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes.selectedFeature?.currentValue?.id !==
      changes.selectedFeature?.previousValue?.id) && !changes.selectedFeature?.firstChange ) {
        // feature change detected !
        this.getLinks();
    }
  }

  public addText(e: Event) {
    e.stopPropagation();
    this.show = true;
  }

  public async getLinks() {
    this.text = null;
    this.show = false;
    this.objectDescriptions = [];
    const values =  await this.elementTextService.filter({targetObjectId: this.selectedFeature.id});
    if (values.isOk) {
      this.objectDescriptions = values.data;
    }
    this.changeDetector.markForCheck();
  }

  /**
   * usage of linkify, check class / component comments !
   * @param s
   * @param index
   */
  public getText(s: string, index: number) {
    const element: HTMLElement = document.getElementById('link-' + index.toString());
    const options = {
      target : {
        url : '_blank'
      },
      format: function (value, type) {
        const first = value.split('//')[1];
        if (first) {
          value = first;
        }
        value = value.split('/')[0];
        return value;
      },
      validate: true
    };
    return element.innerHTML = linkifyHtml(s, options);
  }

  public async removeLink(value: ElementTextModel, e: Event) {
    e.stopPropagation();
    await this.elementTextService.remove(value);
    this.getLinks();
  }

  public edit(s: ElementTextModel, e: Event) {
    e.stopPropagation();
    this.newDescription = s;
    this.text = s.description;
    this.show = true;
  }

  public async saveDescription(value: ElementTextModel, e: Event) {
    e.stopPropagation();
    if (this.text) {
      this.newDescription = new ElementTextModel();
      if (!value.id) {
        value.description = this.text;
        value.targetObjectType = this.selectedFeature.type;
        value.targetObjectId = this.selectedFeature.id.toString();
        await this.elementTextService.create(value);
      } else {
        value.description = this.text;
        await this.elementTextService.edit(value);
      }
      this.getLinks();
    }
  }

  public cancel(e?: Event) {
    e.stopPropagation();
    this.newDescription = new ElementTextModel();
    this.show = false;
    this.text = null;
  }
}
